export const AssetStatusTranslation: { [key: number]: string } = {
  1: $localize`Clean`,
  2: $localize`Dirty`,
  3: $localize`In Storage`,
  4: $localize`In Use`,
};
